var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center",style:({padding: this.tbPadding + 'px' + ' 0'})},[_c('div',[_c('img',{style:({width: this.imgWidth + 'px'}),attrs:{"src":require("@/assets/images/empty@3x.png")}})]),_c('div',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }